import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import { serviceColumns } from './RecordCells';
import {withRouter} from "react-router-dom";
import withPermissions from "../WithPermissions";
class VehiclesOperationsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true,
            loading:false,
        }

    }
    handleOperationDetail = (operationId) => {
        this.props.history.push(`/service-detail/${operationId}`);
    }
    /*handleDelete = async (vehicleId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/vehicle/delete/'+vehicleId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Kullanıcı başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }*/
    render() {
        const { pending } = this.state;
        const { vehicleID } = this.props;
        const columns = serviceColumns({ motor: false, canView: true, canDelete: false, onView: row => this.handleOperationDetail(row.id) });

        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/operation/by-vehicle/"+vehicleID}
                columns={columns}
                onRowClicked={row => this.handleOperationDetail(row.id)}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(VehiclesOperationsTable));
